/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfPagedResultDtoOfOperationalWorkspaceSummaryDto } from "../models/AjaxResponseOfPagedResultDtoOfOperationalWorkspaceSummaryDto";
import type { UpdateWorkspaceOrganizationInput } from "../models/UpdateWorkspaceOrganizationInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalWorkspaceOrganizationsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPagedResultDtoOfOperationalWorkspaceSummaryDto Success
   * @throws ApiError
   */
  public getByOrganization({
    organizationId,
    filter,
    includeInactive,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    organizationId: number;
    filter?: string;
    includeInactive?: boolean;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfOperationalWorkspaceSummaryDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/workspaces",
      path: {
        organizationId: organizationId,
      },
      query: {
        filter: filter,
        includeInactive: includeInactive,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfPagedResultDtoOfOperationalWorkspaceSummaryDto Success
   * @throws ApiError
   */
  public lookup({
    filter,
    includeInactive,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    includeInactive?: boolean;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfOperationalWorkspaceSummaryDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/workspaces/lookup",
      query: {
        filter: filter,
        includeInactive: includeInactive,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    workspaceId,
    requestBody,
  }: {
    workspaceId: number;
    requestBody?: UpdateWorkspaceOrganizationInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/workspaces/{workspaceId}/organization",
      path: {
        workspaceId: workspaceId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
